import Model from '../contrat.model'

export default {
  edit: ({ PUT }, model) =>
    new Promise((resolve, reject) => {
      if (!(model instanceof Model)) {
        return reject(new Error(
          `Erreur paramètre : Model attendu mais reçu "${model.constructor.name}"`
        ))
      } else if (model.isNew()) {
        return reject(new Error(`Erreur paramètre : Model is new`))
      }

      return PUT(`production/contrats/${model.id}`, model)
        .then(reponse => {
          const data = reponse.data
          if (reponse.status === 200 && data.id) {
            const model = new Model(data)
            resolve(model)
          } else {
            reject(reponse.status)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
}
